module.exports = __webpack_public_path__ + "img/icon_law_dark_img.89d490b1.png";